export const GET_TASKS_SAGA = '@@tasks/GET_TASKS_SAGA';
export const GET_TASKS = '@@tasks/GET_TASKS';
export const SAVE_TASKS_SAGA = '@@tasks/SAVE_TASKS_SAGA';
export const SAVE_TASK_SAGA = '@@tasks/SAVE_TASK_SAGA';
export const UPDATE_TASK_SAGA = '@@tasks/UPDATE_TASK_SAGA';
export const UPDATE_TASK_RECORD_SAGA = '@@tasks/UPDATE_TASK_RECORD_SAGA';
export const UPDATE_SPRINT_SAGA = '@@sprints/UPDATE_SPRINT_SAGA';
export const UPDATE_TASK_TIMELINE_SAGA = '@@tasks/UPDATE_TASK_TIMELINE_SAGA';
export const UPDATE_TASK_DATES_SAGA = '@@tasks/UPDATE_TASK_DATES_SAGA';
export const FETCH_TASK_SAGA = '@@tasks/FETCH_TASK_SAGA';
export const CREATE_TASK_SAGA = '@@tasks/CREATE_TASK_SAGA';
export const DELETE_TASK_SAGA = '@@tasks/DELETE_TASK_SAGA';
export const DELETE_SUB_TASK_SAGA = '@@tasks/DELETE_SUB_TASK_SAGA';
export const CREATE_SUB_TASK_SAGA = '@@tasks/CREATE_SUB_TASK_SAGA';
export const CREATE_MULTIPLE_SUB_TASKS_SAGA =
  '@@tasks/CREATE_MULTIPLE_SUB_TASKS_SAGA';
export const CREATE_DEPENDENCY_SAGA = '@@tasks/CREATE_DEPENDENCY_SAGA';
export const DEPENDENCY_CREATED_SAGA = '@@tasks/DEPENDENCY_CREATED_SAGA';
export const DEPENDENCY_REMOVED_SAGA = '@@tasks/DEPENDENCY_REMOVED_SAGA';
export const DEPENDENCIES_REMOVED_SAGA = '@@tasks/DEPENDENCIES_REMOVED_SAGA';
export const BULK_DEPENDENCY_DELETION_FOR_PHASES_AND_TASKS_FROM_TIMELINE =
  'BULK_DEPENDENCY_DELETION_FOR_PHASES_AND_TASKS_FROM_TIMELINE';
export const DEPENDENCIES_OPERATIONS_SAGA =
  '@@tasks/DEPENDENCIES_OPERATIONS_SAGA';
export const REMOVE_AS_SUBTASK = '@@tasks/REMOVE_AS_SUBTASK';
export const REMOVE_AS_SUBTASK_SUCCESS = '@@tasks/REMOVE_AS_SUBTASK_SUCCESS';
export const RESET_ENTITY_DATES = '@@tasks/RESET_ENTITY_DATES';
export const UPDATE_TASK_RECORD_WITH_LATEST_DATA =
  '@@tasks/UPDATE_TASK_RECORD_WITH_LATEST_DATA';
export const DEPENDENCY_CREATION_THROUGH_TIMELINE =
  '@@tasks/DEPENDENCY_CREATION_THROUGH_TIMELINE';
export const DELETE_DEPENDENCY_RELATIONS_SAGA =
  '@@tasks/DELETE_DEPENDENCY_RELATIONS_SAGA';
export const ADD_SUB_TASK_SAGA = '@@tasks/ADD_SUB_TASK_SAGA';
export const ADD_TASK_BELOW_SAGA = '@@tasks/ADD_TASK_BELOW_SAGA';
export const REMOVE_TEMPORARY_TASK_SAGA = '@@tasks/REMOVE_TEMPORARY_TASK_SAGA';
export const BULK_UPDATE_WBS_SAGA = '@@tasks/BULK_UPDATE_WBS_SAGA';
